export const creationAndAdministrationInstitutionsText =
  'Creación y administración de instituciones'
export const documentManagementText = 'Administración de documentos'
export const adminManagementText = 'Gestión de administradores'
export const packagesAdministrationText = 'Administración de paquetes'
export const destinationsAdministrationText = 'Administración de destinos'
